import * as Sentry from '@sentry/react-router';
import { reactRouterTracingIntegration } from '@sentry/react-router';
import { logToConsole } from '~/logging/consoleLogger';
import type { Integration } from '@sentry/core';
import { httpClientIntegration, replayIntegration } from '@sentry/browser';
import { preventFastSpans } from '../../server/sentryUtil';

export function initSentryTracking() {
  const { TG_SENTRY_SHARED_CONFIG, enableSentry, enableSentrySession } = window.TG_CLIENT_CONFIG.trackingConfig;
  
  if (!enableSentry) return;

  const sentryIntegrations: Integration[] = [httpClientIntegration(), reactRouterTracingIntegration()];

  if (enableSentrySession) {
    sentryIntegrations.push(
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    );
  }

  const sentryOptions = {
    ...TG_SENTRY_SHARED_CONFIG,// If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    integrations: sentryIntegrations,
    beforeSendTransaction: preventFastSpans,

    normalizeDepth: 10 // Für die Darstellung von nested Objekten im Context, See: https://sentry.zendesk.com/hc/en-us/articles/30338939116955-Why-are-nested-objects-in-the-context-hidden
  };
  logToConsole({ loggerName: 'sentry', logLevel: 'INFO', message: 'Client-Side Sentry Initialization', args: [JSON.stringify(sentryOptions)] })
  Sentry.init(sentryOptions);
}
